(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsDeleteController',ObservationDefinitionsDeleteController);

    ObservationDefinitionsDeleteController.$inject = ['ObservationDefinitions', '$uibModalInstance', 'parameters', 'SoopkitchenUtils'];

    function ObservationDefinitionsDeleteController(ObservationDefinitions, $uibModalInstance, parameters, SoopkitchenUtils) {
        var vm = this;
        
        /**** Properties ****/
        vm.label = parameters.label;
        vm.waiting = false;
        
        /**** Methods ****/
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function successDelete() {
            SoopkitchenUtils.invokeSweetAlert('Observation Definitions Deleted', vm.label + ' has been deleted', 'success', function () {
                location.reload();
            });
            $uibModalInstance.dismiss('cancel');
            vm.waiting = false;
        }
        
        function failureDelete(response) {
            SoopkitchenUtils.prettyError(response);
            $uibModalInstance.dismiss('cancel');
            vm.waiting = false;
        }
        
        function confirmDelete() {
            vm.waiting = true;
            ObservationDefinitions.confirmDelete(vm.label, successDelete, failureDelete)
        }
    }
})();
